import { Environment } from './environment.types';

const baseUrl = 'https://pdtf-pipeline-dev.collaborativeconveyancing.com';

const oAuthConfig = {
  issuer: 'https://keycloak-dev.collaborativeconveyancing.com/realms/cc-dev',
  redirectUri: baseUrl,
  clientId: 'pdtf-cases-angular',
  responseType: 'code',
  scope: 'openid profile email',
  requireHttps: true, // Change to false for local development
};

export const environment = {
  production: false,
  application: {
    baseUrl,
    name: 'PDTF Cases (dev)',
  },
  oAuthConfig,
  apis: {
    default: {
      url: 'https://pdtf-pipeline-dev.purpletree-72de4576.uksouth.azurecontainerapps.io',
      rootNamespace: 'PdtfCases',
    },
  },
  pipeline: {
    httpBase: 'https://pdtf-pipeline-dev.purpletree-72de4576.uksouth.azurecontainerapps.io',
    wsBase: 'wss://pdtf-pipeline-dev.purpletree-72de4576.uksouth.azurecontainerapps.io',
  },
  appInsights: {
    // Replaced by CI (pdtf-cases-spa-dev variable group) at build time.
    // Stays as this literal for local `ng serve`, which TelemetryService
    // treats as "off" (it skips init when the value starts with '#{').
    connectionString: 'InstrumentationKey=58ed8c95-b019-47dc-ac7e-cfefb15bc7e3;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=f64ffa9b-671c-465a-8298-9fe812c4c40c',
  },
} as Environment;
